
import { setFocusForAccessibility } from '@/plugins/accessibility';
import { find, map, get, forEach } from 'lodash';
import { isTrueString } from '@/utils';
import config from './config.json';
import { mapGetters } from 'vuex';

export const customDropdown = {
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getBaseMetadataById: 'services/getBaseMetadataById',
        }),
        getFieldName() {
            return get(this.getBaseMetadataById(this.index), `description${this.upperLocale}`, '');
        },
        getTextValue() {
            if(this.value === null) {
                return '';
            }

            if(this.getConfig.multiple) {
                let textValue = map(this.value, v => find(this.options, o => o.value === v)?.text ?? '');
                return textValue.join(', ');
            }

            return find(this.options, o => o.value === this.value)?.text ?? '';
        },
        getConfig() {
            const configId = (this.id.indexOf('traveler_status') !== -1) ? 'traveler_status-all' : this.id;
            const currentConfig = find(config, (c, key) => key === configId);

            return {
                multiple: isTrueString(currentConfig?.multiple ?? false),
                outlined: isTrueString(currentConfig?.outlined ?? true),
                icon: currentConfig?.icon ?? undefined,
            };
        }
    },
    methods: {
        selectChange(value) {
            this.$emit('update:value', value);

            if(this.getConfig.multiple) {
                return;
            }

            setFocusForAccessibility(this.id);
        },
        checkRequiredField() {
            this.displayHasRequired = this.required && !this.value;
        },
        selectMultiple(options) {
            let value = [];

            forEach(options, o => {
                if(!o.selected) {
                    return;
                }
                value.push(o.value);
            });

            this.selectChange(value);
        },
    }

};
